<template>
  <div class="form" style="overflow: auto; height: inherit">
    <v-skeleton-loader
      v-if="!form.schema"
      type="article,article, actions"
    ></v-skeleton-loader>
    <v-container fluid class="containerForm" v-else>
      <v-form ref="form" v-model="valid" @submit.prevent="validateForm" :key="key">
        <div class="row ma-0 objectClass">
          <div v-for="(section, sectionName) in form.schema.sections" :key="sectionName" :class="Object.keys(form.schema.sections).length > 1 ? ('row ma-0 pl-2 pt-2 col-' + (12 / Object.keys(form.schema.sections).length) + ' d-block section') : 'row ma-0 pt-2'">
            <span class="py-2 h4 title mb-6" v-if="Object.keys(form.schema.sections).length > 1">{{section.title ? $t(section.title) : ''}}</span>
            <div :class="field.class ? field.class : 'col col-12 pa-0'" v-for="(field, fieldName) in section.fields" :key="fieldName" v-if="field.component && !field.hide">
              <div class="row ma-0 objectClass">
                <FormComponentList :field="field" :fieldName="fieldName" :model="form.model" :key="keys[fieldName]" />
              </div>
            </div>
          </div>
        </div>
      </v-form>
      <SuccessErrorAlertComponent v-if="$store.state.alerts.message" />
      <v-layout row class="mt-2">
        <v-spacer></v-spacer>
        <div class="registerForm" v-if="!form.params.buttons">
          <v-btn v-if="form.params.resetBtn && form.params.resetBtn.action" outlined color="white" class="mt-1 mr-3" @click="$emit('launchFunction', form.params.resetBtn.functionName)">{{ $t("reset") }}</v-btn>
           <v-btn v-if="step" color="white" class="mr-3" outlined :disabled="disableConfirm" @click="validateForm(true)">{{ $t("formSaveAndClose") }}</v-btn>
           <v-btn color="white" class="mt-1 mr-3" depressed outlined :disabled="disableConfirm" @click="validateForm(step ? false : true)">{{ $t(form.params && form.params.buttonConfirmTitle ? form.params.buttonConfirmTitle : "formSave") }}</v-btn>
        </div>
        <div class="registerForm" v-else>
          <v-btn v-for="(button, index) in form.params.buttons" :key="index" x-large color="white" class="mt-1 mr-3" outlined @click="launchFunction(button)">{{ $t(button.title) }}</v-btn>
        </div>
      </v-layout>
      <v-dialog v-model="checkBeforeDialog" width='800'>
          <v-card>
            <v-toolbar tile flat dark class="bg-gradient">
                 <v-toolbar-title>{{checkBeforeDialogTitle}}</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-btn outlined dark depressed @click.native="cancelDialog" class="ml-3">{{$t('cancel')}}</v-btn>
                <v-btn outlined dark depressed @click="validateAction(step ? false : true)" class="ml-3">{{$t('confirm')}}</v-btn>
            </v-toolbar>
            <v-card-text class="pt-4">
                <v-row>
                  <v-col cols="12">
                    {{checkBeforeDialogText}}
                  </v-col>
                  <v-col cols="12" v-if="checkBeforeDialogField">
                    <vCustomSelect :model='form.model' :fieldName="checkBeforeDialogField.fieldName" :field="checkBeforeDialogField" />
                  </v-col>
                  <v-col cols="12" v-if="checkBeforeDialogImpact">
                      <v-checkbox class="mt-0 pt-0" hide-details v-model="form.model['acceptImpact']" :label="$t('impactCheckBoxLabel')"></v-checkbox>
                  </v-col>
                  <v-col cols="12" v-if="checkBeforeDialogError">
                      <b class="red--text">{{ checkBeforeDialogError }}</b>
                  </v-col>
                </v-row>
            </v-card-text>
          </v-card>
      </v-dialog>
    </v-container>
  </div>
</template>

<script>
import SuccessErrorAlertComponent from "@/components/alerts/SuccessErrorAlertComponent";
import GenericDataService from '@/services/GenericDataService'
import { i18n } from "@/i18n";
import { mapActions } from "vuex";
import FormComponentList from "@/components/forms/FormComponentList";
import vCustomSelect from '@/components/forms/inputs/v-custom-select'

export default {
  name: "FilterFormComponent",
  components: {
    SuccessErrorAlertComponent,
    FormComponentList,
    vCustomSelect
  },
  props: ["form", "action", "step", "saveAtInput"],
  data() {
    return {
      checkBeforeDialog:false,
      checkBeforeDialogImpact: false,
      checkBeforeDialogField: false,
      checkBeforeDialogTitle: "",
      checkBeforeDialogText: "",
      checkBeforeDialogError: false,
      publicPath:process.env.BASE_URL,
      valid: null,
      disableConfirm: false,
      key: 0,
      keys: [],
    };
  },
  mounted() {
    this.showHideConditionalFields();
  },
  computed: {
    model: function () {
      return Object.assign({}, this.form.model);
    }
  },
  watch: {
    // Permet de supprimer la valeur du model lorsqu'une valeur dépend d'une autre (ex: Assignement => Vendeur attribué dépend du PDV)
    model: {
      handler(newModel, oldModel) {
        for (var fieldName in newModel) {
          if(!oldModel.hasOwnProperty(fieldName) || oldModel[fieldName] !== newModel[fieldName]) {
            for (var [sectionName, section] of Object.entries(this.form.schema.sections)) {
              if(section.fields.hasOwnProperty(fieldName)){ // Permet de récupérer le champ qui vient d'être update
                if(section.fields[fieldName].hasOwnProperty('depends_fields') || section.fields[fieldName].hasOwnProperty('conditional_fields')) {
                  if(section.fields[fieldName].hasOwnProperty('depends_fields')) {
                    for (var dependFieldName of section.fields[fieldName].depends_fields) {
                      // delete this.form.model[dependFieldName];
                      // delete this.model[dependFieldName];
                      this.keys[dependFieldName] = this.keys[dependFieldName] ? this.keys[dependFieldName] + 1 : 1;
                    }
                  } else if(section.fields[fieldName].hasOwnProperty('conditional_fields')) {
                    this.showHideConditionalFields();
                  }
                  //this.$forceUpdate();
                }
              }
            }
          }
        }
        if(this.saveAtInput && !this.disableConfirm) {
            this.validateForm();
        }
      },
      deep: true
    },
  },
  methods: {
    ...mapActions("alerts", ["setAlert"]),

    validateAction(saveAndClose = false){
        this.checkBeforeDialogError = false
        if(this.checkBeforeDialogField){
          if(!this.form.model[this.checkBeforeDialogField.fieldName])
            this.checkBeforeDialogError = "fieldsAreRequired";
        }
        if(this.checkBeforeDialogImpact){
          if(!this.form.model['acceptImpact'])
            this.checkBeforeDialogError = "fieldsAreRequired";
        }
        if(!this.checkBeforeDialogError)
        this.$emit("confirmAction", saveAndClose);
    },
    validateForm(saveAndClose = false, url = false) {
      // Supprime les objects vides
      this.disableConfirm = true
      for (var fieldName in this.form.model) {
        if(Array.isArray(this.form.model[fieldName])) {
          this.form.model[fieldName] = this.form.model[fieldName].filter(function(value) {
            if((Object.keys(value).length === 0 || Object.keys(value).some((k) => value[k] === "" || !value[k])) && (typeof(value) == 'array' || typeof(value) == 'object') && fieldName != "files" && fieldName != "stock_selection")
              return false;
            return true;
          });
        }
      }
      //return false;
      if (this.$refs.form.validate()) {
        if(this.form.schema.options.checkBefore){
            GenericDataService.postData(this.form.schema.options.checkBefore.url, this.form.model).then((response) => {
              if(response.data.data && response.data.data.title){
                if(response.data.data.var){
                  this.checkBeforeDialogTitle = this.$t(response.data.data.title, {var: response.data.data.var});
                }
                else 
                  this.checkBeforeDialogTitle = this.$t(response.data.data.title);

                this.checkBeforeDialogText = this.$t(response.data.data.text);
                if(response.data.data.impact)
                  this.checkBeforeDialogImpact = true
                if(response.data.data.field)
                  this.checkBeforeDialogField = response.data.data.field

                this.checkBeforeDialog = true;
              } else {
                this.$emit("confirmAction", saveAndClose);
              }
              setTimeout(() => {
                this.disableConfirm = false
              }, 500);
            }).catch((e) => {
              this.disableConfirm = false
            })
        } else {
          this.$emit("confirmAction", saveAndClose);
          setTimeout(() => {
            this.disableConfirm = false
          }, 500);
          
        }
      } else {
        setTimeout(() => {
            this.disableConfirm = false
          }, 500);
      }
    },
    showHideConditionalFields() {
      let forcedHide = [];
      
      for (var [sectionName, section] of Object.entries(this.form.schema.sections)) {
        if(section.hasOwnProperty('fields')) {
          
          for (var [fieldName, field] of Object.entries(section.fields)) {
            
            if(field.hasOwnProperty('conditional_fields')) {
              for (var [conditionalFieldsSectionName, conditionalFieldsSection] of Object.entries(field.conditional_fields)) {
                
                for (var conditionalField of conditionalFieldsSection) {
                  
                  if(this.form.schema.sections[conditionalFieldsSectionName] && this.form.schema.sections[conditionalFieldsSectionName].hasOwnProperty('fields') && this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField]) {
                    
                      
                    if(this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].hasOwnProperty('conditional_of')) {
                      var fieldCanBeVisible = true;
                      for (var conditionalOf in this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of) {
                        if(conditionalOf === fieldName) {
                          // Check sur la value
                          let fieldNameCondition = 'value'; // valeur par défaut
                          if(this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf].hasOwnProperty('field')){ //si field est défini on remplace value par un autre champ
                              fieldNameCondition = this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf].field
                          }
                          if(this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf].hasOwnProperty(fieldNameCondition)) {
                            if(typeof this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition] === 'string') {
                              if(this.model[fieldName] !== this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition]) {
                                fieldCanBeVisible = false;
                              }
                            } else if (typeof this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition] === 'object') {
                              if(!this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition].includes(this.model[fieldName])) {
                                fieldCanBeVisible = false;
                              }
                            } else if (typeof this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition] === 'boolean') {
                              let valueModel = typeof this.model[fieldName] === 'object' && this.model[fieldName] !== null ? (this.model[fieldName][fieldNameCondition] ? this.model[fieldName][fieldNameCondition] : null) : this.model[fieldName];

                              // Début -- Traitement custom pour afficher le nom du RP dans le titre Date de début et Fin sur le form opé maketing
                              if(this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf]['updateTitle'] && typeof this.model[fieldName] === 'object' && this.model[fieldName] !== null) {
                                this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].tmpTitle = this.model[fieldName][this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf]['updateTitle']];
                                this.keys[conditionalField] = this.keys[conditionalField] ? this.keys[conditionalField] + 1 : 1;
                              }
                              // Fin -- Traitement custom pour afficher le nom du RP dans le titre Date de début et Fin sur le form opé maketing

                              if(valueModel !== this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition]) {
                                if(typeof valueModel !== "undefined" || (typeof valueModel === "undefined" && this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition] === true)) {
                                  fieldCanBeVisible = false;
                                }
                              }
                            }
                          } else if(Array.isArray(this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf])) {
                            let neededValues = this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf].reduce(function (filtered, field) {
                              if(field.value)
                                filtered.push(field.value);
                              return filtered;
                            }, []);

                            if(!neededValues.includes(this.model[fieldName]))
                              fieldCanBeVisible = false;
                          }
                        }
                      }
                      if(!fieldCanBeVisible || forcedHide[conditionalField] === true) {
                        this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].hide = true;
                        forcedHide[conditionalField] = true;
                      } else {
                        this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].hide = false;
                      }
                    } else if(this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].hasOwnProperty('conditional_property')){
                      this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].properties.forEach(property => {
                          if(property.hasOwnProperty('conditional_of')){
                            var propertyCanBeVisible = true;
                            for (var conditionalOf in property.conditional_of){

                              if(conditionalOf === fieldName) {
                                let fieldNameCondition = 'value';
                                if(property.conditional_of[conditionalOf].hasOwnProperty('value')){
                                  if(typeof property.conditional_of[conditionalOf][fieldNameCondition] === 'string') {
                                    if(this.model[fieldName] !== property.conditional_of[conditionalOf][fieldNameCondition]) {
                                      propertyCanBeVisible = false;
                                    }
                                  } else if (typeof property.conditional_of[conditionalOf][fieldNameCondition] === 'object') {
                                    if(!property.conditional_of[conditionalOf][fieldNameCondition].includes(this.model[fieldName])) {
                                      propertyCanBeVisible = false;
                                    }
                                  } else if (typeof property.conditional_of[conditionalOf][fieldNameCondition] === 'boolean') {
                                    if(this.model[fieldName] !== property.conditional_of[conditionalOf][fieldNameCondition]) {
                                      if(typeof this.model[fieldName] !== "undefined" || (typeof this.model[fieldName] === "undefined" && property.conditional_of[conditionalOf][fieldNameCondition] === true)) {
                                        propertyCanBeVisible = false;
                                      }
                                    }
                                  }
                                }
                              }
                            }
                            if(!fieldCanBeVisible) {
                              property.hide = true;
                            } else {
                              property.hide = false;
                            }
                          }
                      });
                        // for(property in this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].properties){
                        //   if(property.hasOwnProperty('conditional_of')){
                        //     var propertyCanBeVisible = true;
                        //     for (var conditionalOf in property.conditional_of){
                        //       if(conditionalOf === fieldName) {
                        //         if(this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf].hasOwnProperty('value')){
                        //           if(typeof this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition] === 'string') {
                        //             if(this.model[fieldName] !== this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition]) {
                        //               propertyCanBeVisible = false;
                        //             }
                        //           } else if (typeof this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition] === 'object') {
                        //             if(!this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition].includes(this.model[fieldName])) {
                        //               propertyCanBeVisible = false;
                        //             }
                        //           } else if (typeof this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition] === 'boolean') {
                        //             if(this.model[fieldName] !== this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition]) {
                        //               if(typeof this.model[fieldName] !== "undefined" || (typeof this.model[fieldName] === "undefined" && this.form.schema.sections[conditionalFieldsSectionName].fields[conditionalField].conditional_of[conditionalOf][fieldNameCondition] === true)) {
                        //                 propertyCanBeVisible = false;
                        //               }
                        //             }
                        //           }
                        //         }
                        //       }
                        //     }
                        //     if(!fieldCanBeVisible) {
                        //       property.hide = true;
                        //     } else {
                        //       property.hide = false;
                        //     }

                        //   }
                        // }
                    }
                  }
                }
              }
            }
          }
        }
      }
    },
    cancelDialog(){
      this.checkBeforeDialogTitle = "";
      this.checkBeforeDialogText = "";
      this.checkBeforeDialog = false;
    },
    launchFunction(button) {
        if(button.action) {
            if(button.action === 'function' && button.functionName === 'validateForm') {
                this.validateForm(true, button.url ? button.url : false);
            }

            // Ici on peux check si l'action est un emit et faire le dev nécessaire
        }
    }
  },
};
</script>

<style lang="scss">
.form {
  .containerForm {
   overflow: hidden !important;
    //overflow-y: auto;
  }
  .section {
    .title {
      width: 100%;
      display: inline-block;
    }
  }
  .required {
    label.v-label:after {
      content: '*';
      color: var(--v-error-base);
      margin-left: 5px;
    }
  }
  .registerForm {
    position:absolute;
    right:13px;
    top:10px;
  }
}
</style>
